"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _reactRedux = require("react-redux");

var _actions = require("../redux/actions");

var _utilities = require("../utilities");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FromRedirect = function FromRedirect(_ref) {
  var receiveToken = _ref.receiveToken;

  var _parseFromRedirectLin = (0, _utilities.parseFromRedirectLink)(),
      token = _parseFromRedirectLin.token;

  if (token && token !== null && token !== 'null') {
    receiveToken(token);
  }

  return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    to: "/"
  });
};

var _default = (0, _reactRedux.connect)(null, {
  receiveToken: _actions.receiveToken
})(FromRedirect);

exports.default = _default;